import classnames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';

import Icon from 'dpl/common/components/Icon';

export default function FilterPill({
  label,
  prefixIconName,
  displayDropdownArrow,
  className,
  onClick,
  isSelected
}) {
  return (
    <button className="dib" type="button" onClick={onClick}>
      <span
        className={classnames(
          'flex nowrap items-center br1 pv2 pl3 ba secondary',
          {
            pr3: !displayDropdownArrow,
            pr1: displayDropdownArrow,
            'b--default': !isSelected,
            'b--midnight bg-subtle-light-gray midnight': isSelected
          },
          className
        )}
      >
        {Boolean(prefixIconName) && (
          <Icon
            className={classnames(
              'mr2',
              classnames({
                tertiary: !isSelected,
                midnight: isSelected
              })
            )}
            name={prefixIconName}
            width="24px"
            height="24px"
          />
        )}
        <span className="font-14 fw-medium">{label}</span>
        {displayDropdownArrow && (
          <Icon name="fetch-chevron-down" width="20px" height="20px" />
        )}
      </span>
    </button>
  );
}

FilterPill.propTypes = {
  label: PropTypes.string.isRequired,
  prefixIconName: PropTypes.string.isRequired,
  displayDropdownArrow: PropTypes.bool,
  className: PropTypes.string,
  onClick: PropTypes.func,
  isSelected: PropTypes.bool.isRequired
};

FilterPill.defaultProps = {
  className: null,
  displayDropdownArrow: false,
  onClick: null
};
